<template>
  <div>
    <el-date-picker
      @change="onChange"
      v-model="dtrange_defaultValue"
      type="datetimerange"
      size="mini"
      range-separator="至"
      :start-placeholder="fieldArguments.start_placeholder"
      :end-placeholder="fieldArguments.end_placeholder">
    </el-date-picker>
  </div>
</template>
<script>
  import Common from './js/Common'

  export default {
    name: 'sls-date-time-range',
    mixins:[Common],
    data () {
      return {
        dtrange_defaultValue:[]
      }
    },
    mounted () {
      this.dtrange_defaultValue = this.defaultValue;
    },
    computed: {
      date_time_attrs () {
        return this.Data.date_time_attrs || {}
      }
    },
    methods: {

    },
    watch: {
      defaultValue () {

        this.dtrange_defaultValue = this.defaultValue
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsDateTimeRange.vue